import { render } from "./SingleImageGallery.vue?vue&type=template&id=3cdd40e0"
import script from "./SingleImageGallery.vue?vue&type=script&lang=js"
export * from "./SingleImageGallery.vue?vue&type=script&lang=js"

import "./SingleImageGallery.vue?vue&type=style&index=0&id=3cdd40e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__